const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/training`;

export const errText = (detail) => {
  if (!detail) return "Etwas ist schiefgelaufen. Bitte versuche es erneut.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e?.msg || "").replace(/^Value error, /, "")).filter(Boolean).join(" ");
  return detail.msg || String(detail);
};

let refreshing = null;
const doRefresh = () => {
  refreshing = refreshing || fetch(`${BASE}/auth/refresh`, { method: "POST", credentials: "include" }).then((r) => r.ok).finally(() => { refreshing = null; });
  return refreshing;
};

export async function api(path, { method = "GET", body, retry = true } = {}) {
  let res;
  try {
    res = await fetch(`${BASE}${path}`, {
      method, credentials: "include",
      headers: body ? { "Content-Type": "application/json" } : undefined,
      body: body ? JSON.stringify(body) : undefined,
    });
  } catch (e) {
    throw new Error("Keine Verbindung zum Server");
  }
  if (res.status === 401 && retry && !path.startsWith("/auth/")) {
    if (await doRefresh()) return api(path, { method, body, retry: false });
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(errText(data.detail));
    err.status = res.status;
    throw err;
  }
  return data;
}
